import { render, staticRenderFns } from "./NewAMResetPasswordComponent.vue?vue&type=template&id=bdf2cc78&scoped=true"
import script from "./NewAMResetPasswordComponent.vue?vue&type=script&lang=js"
export * from "./NewAMResetPasswordComponent.vue?vue&type=script&lang=js"
import style0 from "./NewAMResetPasswordComponent.vue?vue&type=style&index=0&id=bdf2cc78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf2cc78",
  null
  
)

export default component.exports